import React, { useEffect, useState } from "react";

function PhoneNumber({ phoneNumber }: { phoneNumber: string }) {
  const [callRailNumber, setCallRailNumber] = useState<string>(phoneNumber);

  useEffect(() => {
    if (phoneNumber) {
      const num = phoneNumber.replace(/\D/g, "");
      if (!window.CallTrk) {
        return;
      }
      const swaps = window.CallTrk.knownSwapAssignments();
      for (const [match, number] of Object.entries(swaps)) {
        if (num === match) {
          setCallRailNumber(number.national ?? phoneNumber);
        } else if (num.endsWith(match.substring(1))) {
          setCallRailNumber(number.national ?? phoneNumber);
        }
      }
    }
  }, [phoneNumber]);

  return (
    <a href={`tel:${callRailNumber}`} className={"text-dark ms-2"}>
      {callRailNumber}
    </a>
  );
}

export default PhoneNumber;
